var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code"},[_c('div',{staticClass:"infobar__icon"},[_c('img',{staticClass:"infobar__icon",attrs:{"svg-inline":"","src":`https://chart.googleapis.com/chart?cht=qr&chl=${_vm.qr}&chs=160x160&chld=L%7C0`,"alt":"icon","focusable":"false","role":"presentation"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }